import { useLocation, useNavigate } from 'react-router-dom'
import '../styles/OtpVerification.css'
import { useState } from 'react';
import { login } from '../pages/services/apiService'


const OtpVerification = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const mobileNumber = location.state?.mobileNumber || '';

    const maskedMobileNumber = mobileNumber
        ? `******${mobileNumber.slice(-4)}`
        : '';

    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // ✅ Validate mobile number and OTP
        if (!mobileNumber) {
            setError("Mobile number is missing. Please go back and enter it.");
            return;
        }

        if (!otp) {
            setError('OTP is required');
            return;
        }

        if (!/^\d{6}$/.test(otp)) {
            setError('Enter valid 6-digit OTP');
            return;
        }

        setError('');
        setLoading(true);

        try {
            const res = await login(mobileNumber, otp);
             console.log("FULL LOGIN RESPONSE 👉", res);
            console.log("Logged in successfully:", res.data);
            // ✅ backend success check
            if (res.success && res.data?.accessToken) {
                const { accessToken, refreshToken } = res.data;

                localStorage.setItem("accessToken", accessToken);
                localStorage.setItem("refreshToken", refreshToken);

                window.location.href = "/dashboard";
            }
        } catch (err) {
            const status = err.response?.status;
            const message = err.response?.data?.message || "Something went wrong";

            if (status === 400) {
                setError(message);
            }
            else if (status === 404) {
                setError(message || "User not found. Redirecting to login...");

                setTimeout(() => {
                    navigate("/login", { replace: true });
                }, 1500);
            }
            else {
                setError(message);
            }
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className='otp-page'>
            <div className="verify-container">
                <div className="verify-left">
                    <img src="/Logo/SkillVerse-Circle.png" alt="SkillVerse Logo" className="verify-logo" />
                    <h1 className="verify-title">SkillVerse Admin OTP Verification</h1>
                </div>

                <div className="verify-right">
                    <p className="otp-info">
                        OTP has been sent to <span>{maskedMobileNumber}</span>
                    </p>

                    <form className="verify-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label className="verify-label">Enter OTP</label>
                            <input
                                type="text"
                                className="otp-input"
                                maxLength={6}
                                inputMode="numeric"
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) =>
                                    setOtp(e.target.value.replace(/\D/g, ""))
                                }
                            />
                            {error && <p className="verify-error">{error}</p>}
                        </div>
                        <button
                            type="submit"
                            className="verify-btn"
                            disabled={loading || !otp || !mobileNumber}
                        >
                            {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default OtpVerification